"use client";

import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

type Props = {
  value: number;
  label: string;
};

export default function GsapCounter({ value, label }: Props) {
  const ref = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { innerText: 0 },        // ✅ target is the DOM element
        {
          innerText: value,
          duration: 2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 90%",
            once: true,
          },
          snap: { innerText: 1 },
          onUpdate: function () {
            el.innerText = Math.floor(Number(el.innerText)).toString();
          },
        }
      );
    });

    return () => ctx.revert(); // ✅ clean up GSAP animations in React
  }, [value]);

  return (
    <div className="flex flex-col items-center text-white gap-3">
      <div className="flex gap-2">
        <span ref={ref} className="text-[70px] font-bold text-white tracking-tight">0</span>
        <span className="text-[70px] font-bold text-white tracking-tight">+</span>
      </div>
      
      <span className="text-xl">{label}</span>
    </div>
  );
}
